export default __webpack_public_path__ + "static/media/2159.503c2648.png";